import React from 'react';
import { SvgIcon, Tooltip } from 'components/elems';

import { classes as cn } from 'shared/styles';

import { cx } from 'helpers';



const iconType = {
  'help': SvgIcon.md.HelpOutline,
  'keyboard': SvgIcon.fa.KeyboardO,
};


const IconBasedBtn = ({ type, size = 28, className, tooltip, ...props }) => {
  const Icon = iconType[type];

  return (
    <button
      className={cx(
        className,
        "inline-flex bn outline-0 br3 pa1 pointer",
        "glow o-50 mid-gray bg-white",
      )}
      data-tip={tooltip}
      {...props}
    >
      <Icon size={size} />
      <Tooltip
        effect="solid"
        place="top"
        globalEventOff='click'
        multiline={true}
        className={cn.tooltipTiny}
      />
    </button>
  );
};


// XXX: Note used, delete..?
export const UserGuideBtn = (props) => (
  <IconBasedBtn type="keyboard" tooltip="Keyboard <br>shortcuts" {...props} />
);

export const HelpMenuBtn = (props) => (
  <IconBasedBtn type="help" tooltip="Help and <br>feedback" {...props} />
);



// WEBPACK FOOTER //
// ./src/components/misc/IconBasedBtn.js